<amplify-authenticator [hideSignUp]="true">
  <!-- Regular sign-in: same mark as WhatsApp; click returns to tenant selection. -->
  <ng-template amplifySlot="header">
    <div class="amplify-login-brand">
      <h1>
        <a routerLink="/" class="brand-home-link" (click)="stayOnTenantSelection()" [attr.aria-label]="'LOGIN.BUSINESS_NAME' | translate">
          <img src="./assets/datakamalogo.svg" alt="data*kama" width="200" height="120" />
        </a>
      </h1>
    </div>
  </ng-template>
  <ng-template
    amplifySlot="authenticated"
    let-user="user"
  >
    <!-- Keep the app unmounted until JWT custom:tenantId matches the selected tenant. -->
    <app-verify-tenant-session [user]="user"></app-verify-tenant-session>
    <ng-container *ngIf="authConfigService.sessionAllowed$ | async; else verifyingTenantSession">
    <mat-sidenav-container [dir]="direction" fullscreen>
      <mat-sidenav
        [mode]="'side'"
        #drawer
        class="sidenav"
        fixedInViewport
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
        [mode]="(isHandset$ | async) ? 'over' : 'side'"
        [opened]="false"
        position="start"
      >
        <div class="sidebar-icon-container">
          <!--
          todo: handle datakama logo as .svg 
          <mat-icon svgIcon="saas-commerce" class="logo"></mat-icon>
          -->
          <!-- Brand mark opens the default dashboard, matching post-login navigation. -->
          <a [routerLink]="homeUrl" class="brand-home-link" [attr.aria-label]="'NAV.DASHBOARD' | translate">
            <img src="./assets/icons/starDatakama.svg" alt="data*kama" width="200" height="120">
          </a>
        </div>
        <mat-divider></mat-divider>
        <mat-nav-list>
          <mat-list-item class="tenantName">
            <div class="tenantInfoContainer">
              <span class="tenantNameText">{{ tenantName }}</span>
              <span class="userName">({{ (username$ | async) || user.username }})</span>
            </div>
          </mat-list-item>
          <!-- Plan allowlist still loading — keep sidebar from looking empty. -->
          <div *ngIf="navPermissionsLoading" class="nav-permissions-loading" aria-hidden="true">
            <mat-progress-spinner
              mode="indeterminate"
              diameter="28">
            </mat-progress-spinner>
          </div>
          <ng-container *ngIf="!navPermissionsLoading">
            <mat-list-item *ngFor="let navItem of navItems">
              <mat-icon [ngStyle]="{'color': '#FFDB58'}" mat-list-icon class="nav-icon material-symbols-outlined">
              {{
                navItem.icon
              }}
              </mat-icon>
              <a mat-list-item routerLink="{{ navItem.url }}">{{ navItem.name ? (navItem.name | translate) : '' }}</a>
            </mat-list-item>
          </ng-container>
          <!-- Logout...-->
          <mat-divider class="divider-line"></mat-divider>
          <mat-list-item>
            <mat-icon [ngStyle]="{'color': '#FFDB58'}" mat-list-icon class="nav-icon material-symbols-outlined">
              logout
            </mat-icon>
            <a mat-list-item (click)="logout()">{{ 'LOGIN.LOGOUT' | translate }}</a>
            
          </mat-list-item>
          <!------------->
        </mat-nav-list>

      </mat-sidenav>
      <mat-toolbar #toolbar class="sidenav-content-container" [class.non-prod-toolbar]="!isProduction">
        <button
          type="button"
          mat-icon-button
          (click)="drawer.toggle()"
          title="Open sidenav"
        >
          <mat-icon class="material-symbols-outlined">
            {{
              direction === 'rtl'
                ? (drawer.opened ? 'chevron_right' : 'chevron_left')
                : (drawer.opened ? 'chevron_left' : 'chevron_right')
            }}
          </mat-icon>
        </button>
        <div class="toolbar-brand">
          <!-- Brand mark opens the default dashboard, matching post-login navigation. -->
          <a [routerLink]="homeUrl" class="brand-home-link" [attr.aria-label]="'NAV.DASHBOARD' | translate">
            <mat-icon svgIcon="datakama-logo" class="header-logo"></mat-icon>
          </a>
          <span *ngIf="!isProduction" class="non-prod-badge">{{ 'NAV.NON_PROD_BADGE' | translate }}</span>
        </div>
        <span class="spacer"></span>
        <!-- Language Switcher -->
        <button mat-button (click)="switchLanguage('en')">EN</button>
        <button mat-button (click)="switchLanguage('he')">HE</button>
        <!-- End Language Switcher -->
        <button
          mat-icon-button
          aria-label="account circle with outlined person icon"
          [matMenuTriggerFor]="useroptions"
        >
          <mat-icon class="material-symbols-outlined">person_filled</mat-icon>
        </button>
        <button
          mat-icon-button
          aria-label="account circle with outlined person icon"
          [matMenuTriggerFor]="settingsoptions"
        >
          <mat-icon class="material-symbols-outlined">settings</mat-icon>
        </button>
      </mat-toolbar>
      <mat-menu #useroptions="matMenu">
        <ng-template #loggedOut>
          <button mat-menu-item>
            <mat-icon class="material-symbols-outlined">lock_open</mat-icon>
            <span>Login</span>
          </button>
        </ng-template>
        <span style="margin: 8px">{{ (username$ | async) || user.username}}</span>
        <mat-divider></mat-divider>
        <button (click)="logout()" mat-menu-item>
          <mat-icon class="material-symbols-outlined">logout</mat-icon>
          <span>{{ 'NAV.SIGN_OUT' | translate }}</span>
        </button>
        <button (click)="logoutEverywhere()" mat-menu-item>
          <mat-icon class="material-symbols-outlined">devices</mat-icon>
          <span>{{ 'NAV.SIGN_OUT_EVERYWHERE' | translate }}</span>
        </button>
      </mat-menu>
      <mat-menu #settingsoptions="matMenu">
        <button *ngIf="isTagsAllowed" (click)="navigateToTags()" mat-menu-item>
          <mat-icon class="material-symbols-outlined">label</mat-icon>
          <span>{{ 'NAV.TAGS' | translate }}</span>
        </button>
        <button *ngIf="isOpsAllowed" (click)="navigateToUsersList()" mat-menu-item>
          <mat-icon class="material-symbols-outlined">supervisor_account</mat-icon>
          <span>{{ 'NAV.USERS_LIST' | translate }}</span>
        </button>
        <button *ngIf="isTenantConfigAllowed" (click)="navigateToTenantConfig()" mat-menu-item>
          <mat-icon class="material-symbols-outlined">settings_applications</mat-icon>
          <span>{{ 'NAV.TENANT_CONFIG' | translate }}</span>
        </button>
        <button *ngIf="(isTenantAdmin$ | async) && isChatAdminAllowed" (click)="navigateToChatAdmin()" mat-menu-item>
          <mat-icon class="material-symbols-outlined">forum</mat-icon>
          <span>{{ 'NAV.CHAT_ADMIN' | translate }}</span>
        </button>
        <button *ngIf="(isPosAdmin$ | async) && isPosAllowed" (click)="navigateToPosSync()" mat-menu-item>
          <mat-icon class="material-symbols-outlined">point_of_sale</mat-icon>
          <span>{{ 'NAV.POS_SYNC' | translate }}</span>
        </button>
        <button *ngIf="(isPosAdmin$ | async) && isOpsAllowed" (click)="navigateToScheduledTasks()" mat-menu-item>
          <mat-icon class="material-symbols-outlined">schedule</mat-icon>
          <span>{{ 'NAV.SCHEDULED_TASKS' | translate }}</span>
        </button>
        <button (click)="openTaxCalculator()" mat-menu-item>
          <mat-icon class="material-symbols-outlined">calculate</mat-icon>
          <span>{{ 'NAV.TAX_CALCULATOR' | translate }}</span>
        </button>
      </mat-menu>

      <div class="content" #main>
        <router-outlet></router-outlet>
      </div>

      <div class="footer" #footer>
        <div class="footer-text">
          <label *ngIf="!isProduction">{{ 'NAV.NON_PROD' | translate }}</label>
          <span>{{ 'NAV.MENU_PROFIT_MANAGER' | translate }} &copy; 2024 Data*Kama</span>
          <label *ngIf="!isProduction">{{ 'NAV.NON_PROD' | translate }}</label>
          <!--
          <span class="spacer"></span>
          <span>
            Powered by SaaS Factory
          </span>
          -->
        </div>
      </div>
    </mat-sidenav-container>
    </ng-container>
    <ng-template #verifyingTenantSession>
      <div class="amplify-login-brand tenant-session-verifying">
        <h1>
          <img src="./assets/datakamalogo.svg" alt="data*kama" width="200" height="120" />
        </h1>
        <mat-spinner diameter="36"></mat-spinner>
      </div>
    </ng-template>
  </ng-template>
</amplify-authenticator>
